<script setup>
    import { onMounted } from 'vue';

    import { APP } from '@/services/localhost';
    import { DIR_P } from '@/services/localhost';


    // ONMOUNTED
        onMounted(() => {
            setTimeout(() => { __load_1(); }, 1000);
            setTimeout(() => { __load_1(); }, 2000);
            setTimeout(() => { __load_1(); }, 3000);
            setTimeout(() => { __load_1(); }, 4000);
            setTimeout(() => { __load_1(); }, 5000);

            if(APP() == 1){
                document.querySelectorAll(`body > #app`).forEach(item => { item.classList.add(`centerr_m`); })
            }

        });
    // ONMOUNTED

    // FUNCTION
        const __load_1 = () => {
            document.querySelectorAll(`.__LOAD__1`).forEach(item => {
                if(item.style.display == 'none'){
                    item.querySelector(`div`).style.background = `rgba(0, 0, 0, .2)`;
                }
            })
        }
    // FUNCTION
</script>

<template>
    <router-view :key="$route.fullPath" />

	<!-- EVENTS__ -->
        <div class="__EVENTS__ no_print">
            <div class="__LOAD__1">
                <div class="posf t0 l0 w100p h100p u-s" style="z-index: 910001;">
                    <div class="posf t0 l0 w100p h100p flexx flex_c flex_ac">
                        <div class="flex_1 tac">
                            <div class="p10"><img :src="`${DIR_P()}/web/logo.png`" style="width: 150px" class="dib" /></div>
                            <div class="p10 mt10"><img src="@/assets/img/default/load_2.gif" class="dib w100" /></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dn __LOAD__2">
                <div class="posf t50p l50p p10 cor_666 bd_ccc back_fff br3 u-s" style="z-index: 910001; margin: -24px 0 0 -72px;">
                    <img src="@/assets/img/default/load_1.gif" class="dib w32 h27 pl3 vam" />
                    <span class="dib"><span class="dib p0 m0"></span> Carregando... </span>
                </div>
            </div>
            <div class="dn load_3">
                <div class="posf t0 l0 w100p h100p" style="z-index: 910001; background: rgba(0, 0, 0, .6)">
                    <div class="posf t50p l50p z1 p10" style="margin: -110px 0 0 -110px; font-size: 0;">
                        <div class="lds-eclipse">
                            <span class="posa w100p h100p pt88 fz20 tac cor_fff" style="padding-top: 88px;">Carregando...</span>
                            <div style="box-shadow: 0 4px 0 0 #fff;"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="__ALERTS__"><div class="alerts"></div></div>
            <div class="__ERRORS__"></div>
        </div>
    <!-- EVENTS__ -->

    <!-- PRELOAD_PAGES -->
        <div v-if="APP()!=2" class="__PRELOAD_PAGES__ no_print">
            <div class="posf t0 l0 z-1 w100p h100p flexx flex_c flex_ac">
                <div class="flex_1 tac">
                    <div class="p10"><img :src="`${DIR_P()}/web/logo.png`" style="width: 150px" class="dib" /></div>
                    <div class="p10 mt10"><img src="@/assets/img/default/load_2.gif" class="dib w100" /></div>
                </div>
            </div>
        </div>
    <!-- PRELOAD_PAGES -->
</template>